import { isNil } from 'ramda';
import { commitMutation,
  graphql } from 'react-relay';
import environment from '../../index';
import { basicMutationOnCompleted, onErrorMutation } from '../common/common';

const mutation = graphql`
  mutation UpdateVersionCommentMutation($versionId: ID!, $comment: String!) {
    updateComment(versionId: $versionId, comment: $comment) {
      ok
      error
    }
  }
`;

export default ({ versionId, comment }, done) => {
  const variables = {
    versionId,
    comment
  };

  commitMutation(
    environment(),
    {
      mutation,
      variables,
      updater: (proxyStore, { updateComment: { ok } }) => {
        if (ok) {
          const version = proxyStore.get(versionId);

          if (!isNil(version)) {
            version.setValue(comment, 'comment');
          }
        }
      },
      onCompleted: ({ updateComment }) => basicMutationOnCompleted(updateComment, done),
      onError: error => onErrorMutation(error, done)
    }
  );
};
